import { useRef, useState } from "react";
import { toast } from "sonner";
import { api, formatApiError } from "../../lib/api";

const newId = () => (window.crypto?.randomUUID ? window.crypto.randomUUID() : `${Date.now()}-${Math.random().toString(36).slice(2)}`);

/** Shared save flow: one client_request_id per filled form → server-side idempotent. */
export function useOpSave(type, initial) {
    const [values, setValues] = useState(initial);
    const [saving, setSaving] = useState(false);
    const [lastSaved, setLastSaved] = useState(null);
    const rid = useRef(newId());
    const busy = useRef(false);

    const set = (k) => (v) => setValues((s) => ({ ...s, [k]: v }));
    const clear = () => { setValues(initial); rid.current = newId(); };

    const save = async () => {
        if (busy.current) return;
        busy.current = true;
        setSaving(true);
        try {
            const r = await api.post("/mshop/ops", { type, client_request_id: rid.current, ...values });
            setLastSaved(r.data.op);
            toast.success(r.data.duplicate ? "هذه العملية محفوظة مسبقاً" : "تم حفظ العملية بنجاح");
            clear();
        } catch (e) {
            toast.error(formatApiError(e.response?.data?.detail));
        } finally {
            busy.current = false;
            setSaving(false);
        }
    };
    return { values, set, clear, save, saving, lastSaved, setLastSaved };
}
